









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ScrollTop extends Vue {
  @Prop({ default: 300 }) offsetY!: number;

  showScrollButton = false;

  scrollPixelEveryFrame = 10;

  beforeMount() {
    window.addEventListener('scroll', this.isScrolledContent, { passive: true });
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.isScrolledContent);
  }

  onScroll() {
    const scrollAnimation = window.requestAnimationFrame(this.onScroll);
    const scrollTop = window.scrollY;
    if (scrollTop > 0) {
      window.scrollTo(0, scrollTop - this.scrollPixelEveryFrame);
      this.scrollPixelEveryFrame += 5;
    } else {
      cancelAnimationFrame(scrollAnimation);
      this.scrollPixelEveryFrame = 10;
    }
  }

  isScrolledContent() {
    this.showScrollButton = window.scrollY >= this.offsetY;
  }
}
